var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17537 1.00846C9.63098 0.552845 10.3695 0.552845 10.8251 1.00846C11.2807 1.46407 11.2807 2.20258 10.8251 2.6582L4.64998 8.83333H18.1669C18.8112 8.83333 19.3336 9.35566 19.3336 9.99999C19.3336 10.6443 18.8112 11.1667 18.1669 11.1667H4.64998L10.8251 17.3418C11.2807 17.7974 11.2807 18.5359 10.8251 18.9915C10.3695 19.4471 9.63098 19.4471 9.17537 18.9915L1.0087 10.8249C0.553089 10.3693 0.553089 9.63074 1.0087 9.17512L9.17537 1.00846Z",
    fill: "#707070"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-left.dcdcdd38cf5cc7fc7188f89134df1698.svg";